import priceListImage from 'assets/images/pricing-home.png';
import React from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import MainTemplate from 'templates/MainTemplate/MainTemplate';
import NavBox from './HomeView/NavBox';

const getCurrentLang = () => {
   const lang = localStorage.getItem('KNS_INFO_CURRENT_LANG');

   if (lang === 'eng' || lang === 'ukr') {
      return '/en';
   }

   return '';
};

const Wrapper = styled.div`
   display: flex;
   align-items: center;
   justify-content: center;
   flex-direction: column;
   padding: 20px;
   margin-top: 60px;
`;

const BoxWrapper = styled.div`
   max-width: 450px;
`;

const PRICE_LIST = 'https://pricelist.konsport.com.pl';

export const NewPriceListView = () => {
   const intl = useIntl();

   return (
      <MainTemplate>
         <Wrapper>
            <BoxWrapper>
               <NavBox
                  alt={intl.formatMessage({ id: 'NavBox.2.Alt' })}
                  headline={intl.formatMessage({ id: 'NewPriceListView.Headline' })}
                  description={intl.formatMessage({ id: 'NewPriceListView.Content' })}
                  imageSrc={priceListImage}
                  link={`${PRICE_LIST}${getCurrentLang()}`}
               />
            </BoxWrapper>
         </Wrapper>
      </MainTemplate>
   );
};
